import templateUrl from 'emun.on-demand/templates/od-design-area-fieldset.htm'
import resolve from 'ioc/resolve'

class DesignAreaFieldsetController {
}

let DesignAreaFieldsetComponent = {
    bindings: {
        area: '<',
        areas: '<'
    },
    controller: DesignAreaFieldsetController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default DesignAreaFieldsetComponent;